import React, { FC, HTMLAttributes } from 'react';
import styles from './TooltipText.module.scss';
import classnames from 'classnames';

export interface ITooltipText extends HTMLAttributes<HTMLSpanElement> {
  isShow?: boolean;
}

const TooltipText: FC<ITooltipText> = (props) => {
  const { isShow, className, children } = props;
  const rootClassName = classnames(styles.root, { [styles.show]: isShow }, className);

  return <span className={rootClassName}>{children}</span>;
};

export default TooltipText;
